<template>
  <div class="student_detail">
    <div class="header">
      <el-row>
        
        <el-col :span="24" style="text-align: right;">
          <el-button
            type="primary"
            size="small"
            v-if="task.IsCreate == 1 && !task.SharedScope"
            @click="handleTask('3')"
          >
            编辑
          </el-button>
          <el-button
            type="primary"
            size="small"
            v-if="task.IsCreate == 0 || !task.SharedScope"
            @click="handleTask('4')"
          >
            删除
          </el-button>
          <el-button type="primary" size="small" @click="handleTaskPrint">打印</el-button>
          <el-button type="primary" size="small" @click="handleTaskExport">导出PDF</el-button>
          <el-button
            type="primary"
            size="small"
            v-if="task.IsCreate == 1 && !task.SharedScope"
            @click="handleTask('5')"
          >
            分享
          </el-button>
          <el-button type="primary" size="small" v-if="task.IsCreate == 1 && task.SharedScope" @click="handleTask('6')">
            取消分享
          </el-button>
        </el-col>
      </el-row>
    </div>
    <!--  问题区 start  -->
    <div class="task_questions" style="height: 100%; margin:auto;">
      <div class="task_header">
        <p>
          <label>出题方式：{{ taskTypes[task.Online] }}</label>
          <label>是否计分：{{ task.IsScore ? "计分" : "不计分" }}</label>
        </p>
        <p>
          <label>教材章节：{{ chapter }}</label>
        </p>
      </div>

      <div class="questionsAnalysis" style="">
        <div id="taskContainer" class="questionsLeft">
          <div class="questions">
            <div id="questionsContainer">
              <div
                v-for="(questionPage, pageIndex) in task.pages"
                :key="'pageIndex' + pageIndex"
                :style="{
                  width: (task.SizeType == 1 ? questionPage.PageWidth : task.TrueWidth) + 'mm',
                  height: (task.SizeType == 1 ? questionPage.PageHeight : task.TrueHeight) + 'mm',
                  padding: task.PaddingWidth + 'mm',
                }"
                class="task_page"
              >
                <div v-if="task.Online == 1" id="taskPageOnline" class="w-e-text-container">
                  <div
                    v-for="(question, questionIndex) in questionPage.questions"
                    :id="'question' + question.ID"
                    :key="'question' + question.ID"
                    class="page-question-item w-e-text"
                    :class="{ active: activeQuestion.ID === question.ID }"
                  >
                    <div v-html="question.QuestionStem" @click="questionChange(pageIndex, questionIndex)"></div>
                    <button
                      v-if="question.TaskPrePushQuestions && question.TaskPrePushQuestions.length > 0"
                      :title="'已预设了' + question.TaskPrePushQuestions.length + '道推题'"
                      class="push-count"
                      :style="{top:(question.RegionY - Math.floor(task.PaddingWidth / 210 * 793.69 * 100)/100 - 15) + 'px'}"
                      @click="openPushed(question, questionIndex)"
                    >
                      {{ question.TaskPrePushQuestions.length }}
                    </button>
                  </div>
                </div>
                <div v-if="task.Online == 2" id="taskPageBook">
                  <img
                    :src="questionPage.PageImg"
                    :style="{
                      maxWidth: (task.SizeType != 1 ? task.TrueWidth : questionPage.PageWidth) + 'mm',
                      maxHeight: (task.SizeType != 1 ? task.TrueHeight : questionPage.PageHeight) + 'mm',
                    }"
                  />
                  <div
                    v-for="(question, questionIndex) in questionPage.questions"
                    :id="'question' + question.ID"
                    :key="'question' + question.ID"
                    :style="{
                      top: question.RegionY + 'px',
                      left: question.RegionX + 'px',
                      width: question.RegionW + 'px',
                      height: question.RegionH + 'px',
                    }"
                    :class="{ active: activeQuestion.ID === question.ID }"
                    @click="questionChange(pageIndex, questionIndex)"
                    class="pageQuestion"
                  >
                    <button
                      v-if="question.TaskPrePushQuestions && question.TaskPrePushQuestions.length > 0"
                      :title="'已预设了' + question.TaskPrePushQuestions.length + '道推题'"
                      class="push-count"
                      @click="openPushed(question, questionIndex)"
                    >
                      {{ question.TaskPrePushQuestions.length }}
                    </button>
                  </div>
                </div>
                <div v-if="task.Online == 3" id="jiaofu">
                  <img
                    :src="questionPage.PageImg"
                    :style="{
                      maxWidth: task.SizeType == 1 ? questionPage.PageWidth + 'mm' : task.TrueWidth + 'mm',
                      maxHeight: task.SizeType == 1 ? questionPage.PageHeight + 'mm' : task.TrueHeight + 'mm',
                    }"
                  />
                  <div
                    v-for="(question, questionIndex) in questionPage.questions"
                    :id="'question' + question.ID"
                    :key="'question' + question.ID"
                    :style="{
                      top: question.RegionY + 'px',
                      left: question.RegionX + 'px',
                      width: question.RegionW + 'px',
                      height: question.RegionH + 'px',
                    }"
                    :class="{ active: activeQuestion.ID === question.ID }"
                    @click="questionChange(pageIndex, questionIndex)"
                    class="pageQuestion"
                  >
                    <button
                      v-if="question.TaskPrePushQuestions && question.TaskPrePushQuestions.length > 0"
                      :title="'已预设了' + question.TaskPrePushQuestions.length + '道推题'"
                      class="push-count"
                      @click="openPushed(question, questionIndex)"
                    >
                      {{ question.TaskPrePushQuestions.length }}
                    </button>
                  </div>
                </div>
                <div v-if="task.Online == 4" class="question-page">
                  <p class="title-container" v-if="pageIndex == 0">
                    <span class="paper-name">{{ task.TaskName }}</span>
                  </p>
                  <p class="chapter" v-if="pageIndex == 0">
                    <span>{{ chapter }}</span>
                  </p>
                  <div class="questions">
                    <div
                      v-for="(question, questionIndex) in questionPage.questions"
                      :id="'question' + question.ID"
                      :key="'question' + question.ID"
                      class="question-item"
                      :style="{ width: task.TrueWidth - task.PaddingWidth * 2 + 'mm' }"
                    >
                      <p class="question-type" v-if="countShowType(pageIndex, questionIndex)">
                        {{ question.QuestionTypeName }}
                        <span v-show="task.IsScore">（共{{ countTypeTotalScore(question.QuestionType) }}分）</span>
                      </p>

                      <div
                        class="question-content"
                        :class="{ active: activeQuestion.ID === question.ID }"
                        @click="questionChange(pageIndex, questionIndex)"
                      >
                        <p class="question-no">
                          <span>{{ countType(pageIndex, questionIndex) }}、</span>
                          <span v-show="task.IsScore">（本题{{ question.Score }}分）</span>
                        </p>
                        <div v-if="question.QuestionStem" v-html="question.QuestionStem"></div>
                        <el-image
                          v-else
                          :src="question.QuestionStemImage"
                          :style="{
                            width: question.RegionW + 'px',
                            height: question.RegionH + 'px',
                            display: 'block',
                          }"
                        ></el-image>
                        <div :style="'height: ' + question.AdditionalAnswerArea + 'px'"></div>
                      </div>
                      <button
                        v-if="question.TaskPrePushQuestions && question.TaskPrePushQuestions.length > 0"
                        :title="'已预设了' + question.TaskPrePushQuestions.length + '道推题'"
                        class="push-count"
                        @click="openPushed(question, questionIndex)"
                      >
                        {{ question.TaskPrePushQuestions.length }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="questionRight">
          <div v-if="questions.length == 0 && task.TaskName.length > 0" style="text-align: center;padding: 30px;">
            没有出题选题
          </div>
          <div v-if="questions.length > 0 && activeQuestion != undefined" class="questionInfo" style="">
            <p>
              <i class="el-icon-s-flag" style="color: #ff4e00;"></i>
              <strong>第{{ activeIndex + 1 }}题</strong>
              /
              <strong>共{{ questions.length }}题</strong>
            </p>
            <p>
              <label>【题号】</label>
              <span class="qtype">{{ activeQuestion.QuestionNum }}</span>
            </p>
            <p>
              <label>【题型】</label>
              <span class="qtype">{{ activeQuestion.QuestionTypeName }}</span>
            </p>
            <p>
              <label>【难易程度】</label>
              <span class="hard">
                {{ activeQuestion.DifficultLvl > 0 ? DifficultLvls[activeQuestion.DifficultLvl] : "未知" }}
              </span>
            </p>
            <p v-if="task.IsScore">
              <label>【分值】</label>
              <span>{{ activeQuestion.Score }}分</span>
            </p>
            <!-- 知识点 -->
            <p>
              <label>【知识点】</label>
              <span v-for="(point, pindex) in activeQuestion.TaskForQuestionPoints" :key="'point' + pindex">
                {{ point.PointName + "  " }}
              </span>
            </p>
            <div class="answerDiv">
              <!-- 主观题参考答案 -->
              <div>
                <label>【答案】</label>
                <!-- <el-button
                  @click="openAnswerExplainBox(activeQuestion)"
                  v-if="
                    (activeQuestion.QuestionType == 4 &&
                      (activeQuestion.Answer != '' || activeQuestion.Explain != '')) ||
                      (activeQuestion.QuestionType < 4 && activeQuestion.Explain != '')
                  "
                  type="text"
                  style="margin: 5px; font-size: 10pt;color: gray;padding: 4px;background: #efefef;"
                >
                  点击放大查看答案及解析
                </el-button> -->
                <div
                  class="content"
                  style="padding: 3px 8px;"
                  v-html="activeQuestion.Answer ? activeQuestion.Answer : '未提供'"
                ></div>
              </div>
              <!-- 主观题参考答案 -->
              <div>
                <label>【解析】</label>
                <div
                  class="content"
                  style="padding: 3px 8px;"
                  v-html="activeQuestion.Explain ? activeQuestion.Explain : '未提供'"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="answerExplainBoxShow" center height="60%" title="" width="55%">
      <div class="contentDiv">
        <div class="content" v-if="activeQuestion != undefined">
          <h2>参考答案</h2>
          <div
            v-if="activeQuestion.Answer != ''"
            :class="{ 'w-e-text': activeQuestion.QuestionType > 3 }"
            v-html="
              activeQuestion.QuestionType == 3 ? (activeQuestion.Answer === 'T' ? '对' : '错') : activeQuestion.Answer
            "
          ></div>
          <h2>答案解析</h2>
          <div v-if="activeQuestion.Explain != ''" class="w-e-text" v-html="activeQuestion.Explain"></div>
        </div>
      </div>
    </el-dialog>

    <div
      id="question2ImgForPrint"
      class="question2ImgForPrint"
      :style="{
        width: (task.TrueWidth > 0 ? task.TrueWidth : task.pages.length > 0 ? task.pages[0].PageWidth : 210) + 'mm',
        height: (task.TrueHeight > 0 ? task.TrueHeight : task.pages.length > 0 ? task.pages[0].PageHeight : 297) + 'mm',
      }"
    ></div>
    <!--导出用的显示结束-->

    <!--智能组题的作业打印内容start-->
    <div class="right print-container" ref="printContainer" v-if="task.Online == 4" v-show="false">
      <table
        class="question-page"
        border="0"
        cellpadding="0"
        cellspacing="0"
        :style="{ width: task.TrueWidth + 'mm', height: task.TrueHeight - 1 + 'mm', padding: task.PaddingWidth + 'mm' }"
        v-for="(questionPage, pageIndex) in task.pages"
        :key="'pagePrint4-' + pageIndex"
      >
        <tr>
          <td style="vertical-align: baseline">
            <div
              :style="{
                width: task.TrueWidth - task.PaddingWidth * 2 + 'mm',
                height: task.TrueHeight - task.PaddingWidth * 2 - 1 + 'mm',
              }"
            >
              <p class="title-container" v-if="pageIndex == 0">
                <span class="paper-name">{{ task.TaskName }}</span>
              </p>
              <p class="chapter" v-if="pageIndex == 0">
                <span>{{ chapter }}</span>
              </p>
              <div class="questions">
                <div
                  class="question-item"
                  v-for="(question, questionIndex) in questionPage.questions"
                  :style="{ width: task.TrueWidth - task.PaddingWidth * 2 + 'mm' }"
                  :id="'question' + question.ID"
                  :key="'print-question' + question.ID"
                  :ref="'question' + question.ID"
                >
                  <p class="question-type" v-if="countShowType(pageIndex, questionIndex)">
                    {{ question.QuestionTypeName }}
                    <span v-show="task.IsScore == 1">（共{{ countTypeTotalScore(question.QuestionType) }}分）</span>
                  </p>
                  <p class="question-no">
                    <span>{{ countType(pageIndex, questionIndex) }}、</span>
                    <span v-show="task.IsScore == 1">（本题{{ question.Score }}分）</span>
                  </p>
                  <div class="question-content">
                    <el-image
                      v-if="question.QuestionStemImage"
                      :src="question.QuestionStemImage"
                      :style="{
                        top: '0px',
                        left: '0px',
                        width: question.RegionW + 'px',
                        height: question.RegionH + 'px',
                        display: 'block',
                      }"
                    ></el-image>
                    <div v-else v-html="question.QuestionStem"></div>
                    <div :style="'height: ' + question.AdditionalAnswerArea + 'px'"></div>
                    <div class="answer-explain" v-show="false">
                      <div class="answer">
                        <span>【答案】</span>
                        <div v-html="question.Answer ? question.Answer : '未提供'"></div>
                      </div>
                      <div class="explain">
                        <span>【解析】</span>
                        <div v-html="question.Explain ? question.Explain : '未提供'"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <!--    打印内容end-->
    

    <!-- 加入推题的试题列表dialog -->
    <el-dialog
      title="提示"
      custom-class="searchDialog"
      width="900px"
      :visible.sync="pushedDialog"
      :append-to-body="true"
      top="10vh"
      v-dialogDrag
      :close-on-click-modal="false"
      style="overflow: hidden"
    >
      <div slot="title" class="searchTitle">
        <span style="font-size: 20px">预设的推题</span>
      </div>
      <!-- 已加入推题的列表 -->
      <question-bank-list
        :questions="pushedData"
        :typeName="'pushedData'"
        :editable="false"
        :needFill="false"
        :similarEnable="false"
        :pushEnable="false"
      ></question-bank-list>
    </el-dialog>
    <!-- 加入推题的试题列表dialog end -->
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import QuestionBankList from "./QuestionBankList.vue";

export default {
  name: "TaskDetail",
  components: {
    QuestionBankList,
  },
  props: {
    questions: {
      type: [Object, Array],
    },
    taskIndex: {
      type: Number,
    },
    task: {
      type: Object,
      default: {
        pages: [
          /*{
          questions: [],
          PageID: 0,
          PageNum: 1,
          PageImg: ""
        }*/
        ],
        TaskListID: 0,
        TaskRelTeachingPlanID: 0,
        TeachingPlanID: 0,
        TeachingPlanTitle: "",
        TaskName: "",
        SchoolID: null,
        Author: null,
        Online: 0, //1在线出题   2传题选题
        IsScore: false, //false不计分制   true计分制
        PaperID: 0, //试卷id
        IsShared: 0, //0不共享  1共享
        SharedScope: 0,
        SharedTime: null,
        AddTime: "0001-01-01 00:00:00",
        UpdateTime: "0001-01-01 00:00:00",
        questionCount: 0,
        SizeType: 2,
        TrueWidth: 210,
        TrueHeight: 297,
        PaddingWidth: 10,
      },
    },
    chapter: String,
  },
  data() {
    return {
      deviceWidth: document.documentElement.clientWidth,
      deviceHeight: document.documentElement.clientHeight,
      taskID: 0,
      SharedWork: 0,
      classID: "",
      pageNum: 1,
      pageCount: 0,
      questionNum: 0,
      activeIndex: -1,
      activeQuestion: {
        ID: 0, //题目id
        TaskListID: 0,
        PageID: 0,
        PageNum: 1,
        QuestionNum: 0,
        QuestionType: 1,
        QuestionTypeName: "",
        QuestionStem: "",
        QuestionStemImage: "",
        Answer: "",
        Explain: "",
        DifficultLvl: 0,
        RegionX: 0,
        RegionY: 0,
        RegionW: 0,
        RegionH: 0,
        Score: 0,
        KnowledgePoints: [],
        Sort: 0,
        AdditionalAnswerArea: 0,
        QuestionID: 0, //原题库id
      },
      taskTypes: ["", "在线出题", "传题选题", "教辅选页", "智能组题"],
      DifficultLvls: ["", "容易", "较易", "一般", "较难", "困难"],
      SizeTypes: [
        { value: 1, name: "原教辅尺寸" },
        { value: 2, name: "A4" },
        { value: 3, name: "B5" },
        { value: 4, name: "自定义" },
      ],
      //{classAnswerID : 6030, isRight : 1, judgeScore : 1,answer:'A',taskID:49,studentID:"b26f4b0a-c9bd-469c-a653-1b93d44cfbcc" }
      explainShow: false,
      answerExplainBoxShow: false,
      oldTop: 300,
      newTop: 0,
      sharedScope: 0,

      pushedDialog: false,
      pushedData: [],
    };
  },
  methods: {
    // --- 初始化 ---
    /**
     * 初始化
     */
    init() {
      this.tabIndex = 0;
      this.pageNum = 1;
      this.pageCount = 0;
      this.questionNum = -1;
      this.activeIndex = -1;
      this.activeQuestion = {};
      this.task = {
        pages: [],
        TaskListID: 0,
        TaskRelTeachingPlanID: 0,
        TeachingPlanID: 0,
        TeachingPlanTitle: "",
        TaskName: "",
        SchoolID: null,
        Author: null,
        Online: 0, //1在线出题   2传题选题
        IsScore: false, //false不计分制   true计分制
        PaperID: 0, //试卷id
        IsShared: 0, //0不共享  1共享
        SharedScope: 0,
        SharedTime: null,
        AddTime: "0001-01-01 00:00:00",
        UpdateTime: "0001-01-01 00:00:00",
        SizeType: 2,
        TrueWidth: 210,
        TrueHeight: 297,
        PaddingWidth: 10,
      };
      this.questions = [];
      // this.setQuestionsPageScale();
    },

    back() {
      if (window.opener) {
        window.opener = null;
        window.open("", "_self");
        window.close();
      } else {
        this.$router.back();
      }
    },
    /**
     * 切换题目
     * @param pageIndex
     * @param index
     */
    questionChange(pageIndex, index) {
      let count = 0;
      for (let i = 0; i < this.task.pages.length; i++) {
        if (i < pageIndex) {
          count += this.task.pages[i].questions.length;
        } else {
          break;
        }
      }
      this.activeIndex = count + index;
      this.activeQuestion = this.questions[this.activeIndex];
      console.log(this.activeQuestion);
    },
    /**
     * 处理题目
     * @param question
     */
    parseQuestion(question) {
      let result = question.Answer;
      switch (question.QuestionType) {
        case 3:
          result = question.Answer === "T" ? "正确" : "错误";
          break;
        default:
          break;
      }
      return result;
    },
    // --- 事件 ---
    /**
     * 整合作业的跳转操作
     * @param type 1- 批改作业 2- 查看统计分析 3- work
     */
    handleTask(type) {
      switch (type) {
        case "3": //修改作业
          this.$emit("edit-task", this.task);
          break;
        case "4": //删除作业
          this.$emit("delete-task", this.task);
          break;
        case "5": //分享作业
          this.$emit("share-task", this.task, this.taskIndex);
          break;
        case "6": //取消分享作业
          this.$emit("cancel-share-task", this.task, this.taskIndex);
          break;
        default:
          break;
      }
    },

    // --- axios ---
    /**
     * 获取学生作业详情
     */
    getTaskDetail() {
      this.axios
        .get(window.url + "GetTaskListPageQuesiton?TaskRelTeachingPlanID=" + this.taskID)
        .then((res) => {
          let result = res.data;
          if (result.result === 200) {
            let taskData = result.data;
            this.task = taskData;
            if (this.task.SizeType == 0) {
              this.task.SizeType == 2;
              this.task.TrueWidth = 210;
              this.task.TrueHeight = 297;
            }
            if (this.task.Online == 1 || this.task.Online == 4) {
              //在线出题,智能组卷
              if (!this.task.PaddingWidth || this.task.PaddingWidth == 0) {
                this.task.PaddingWidth = 10;
              }
            }

            this.pageCount = taskData.pages.length;
            this.pageNum = 1;
            for (let taskPage of taskData.pages) {
              this.questions = this.questions.concat(taskPage.questions);
            }
            this.activeIndex = 0;
            this.activeQuestion = this.questions[0];
          }
          this.setQuestionsPageScale();
        })
        .catch((error) => {
          this.$message.error("您的网络开小差了！");
        });
    },
    

    /**
     * 打印作业
     */
    handleTaskPrint() {
      //弹打印提示对话框
      let sizeType = this.SizeTypes[this.task.SizeType - 1].name;
      if (this.task.SizeType > 1) {
        sizeType += "(" + this.task.TrueWidth + ", " + this.task.TrueHeight + ")";
      }
      if (this.task.Online == 1) {
        const pd = {
          TaskListID: this.taskID,
        };
        this.axios.post(window.url + "GetTaskListAndQuestionList",{
			TaskListID : this.task.TaskListID, 
			TeachingPlanID : this.task.TeachingPlanID,
		}).then((res) => {
          if (res.data.result !== 200) {
            this.$message.error({
              message: res.data.message,
            });
            return;
          }
		  console.log(res);
          //获取正常数据.
          let selTaskQuestions = res.data.data.Questions;
		  console.log(selTaskQuestions);
          let nowPage = 0;
          let htmlDocument = `<!DOCTYPE html><html lang="en"><head>
        	      <meta charset="UTF-8">
        	      <title>${this.chapter}-${this.task.TaskName}</title>
        	      <style>
        	          @page{
        	          margin:0;
        	          }
        	          @page print{
        	          margin:0;
        	          }
        	          html, body {
        	              padding:0;
        	              font-size: 10.5pt;
        	              margin:0;
        	              color: #000;
        	              -webkit-font-smoothing: antialiased;
        	              font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif;
        	          }
        	          font[size="7"] {
        	            font-size: 26pt;
        	          }
        	          font[size="6"] {
        	            font-size: 22pt;
        	          }
        	          font[size="5"] {
        	            font-size: 18pt;
        	          }
        	          font[size="4"] {
        	            font-size: 16pt;
        	          }
        	          font[size="3"] {
        	            font-size: 14pt;
        	          }
        	          font[size="2"] {
        	            font-size:12pt;
        	          }
        	          font[size="1"] {
        	            font-size: 10.5pt;
        	          }
        	          .w-e-text img:hover{
        	          box-shadow: none;
        	          }
        	          .w-e-text img{
        	          vertical-align: top;
        	          }

        	      </style>
        	      <script src="./js/wangEditor.min.js"><\/script>
        	  </head>
        	  <body>`;
          for (let i = 0; i < selTaskQuestions.length; i++) {
            let question = selTaskQuestions[i];
            //如果页码与题目不一样时.创建 页码
            if (nowPage !== question.PageNum) {
              //1.1, 如果是第一次 .则不加table结尾, 否则添加table结尾
              if (i !== 0) {
                htmlDocument += `</div></td></tr></table>`;
              }
              //1.2,无论是否第一次都要加table开始.
              htmlDocument += `<table border="0" cellpadding="0" cellspacing="0"  style="page-break-after:always;box-sizing:border-box; width:${
                this.task.TrueWidth
              }mm;height:${this.task.TrueHeight - 1}mm;padding:${
                this.task.PaddingWidth
              }mm;" ><tr><td style="vertical-align: baseline">`;
              htmlDocument += `<div  class="w-e-text-container" style="width:${this.task.TrueWidth -
                this.task.PaddingWidth * 2}mm;max-width:${this.task.TrueWidth -
                this.task.PaddingWidth * 2}mm;max-height:${this.task.TrueHeight -
                this.task.PaddingWidth * 2 -
                1}mm;overflow: hidden">
        	                    <div  class="w-e-text" style="padding:0;overflow: hidden;word-break:normal;font-size: 10.5pt;">
        	                        ${question.QuestionStem}
        	                    </div>`;
              //1.3 加完之的一, 修改当前的page页.
              nowPage = question.PageNum;
              continue;
            }
            //2.0 如果相同, 直接添加题目.
            htmlDocument += `<div  class="w-e-text " style="padding:0;overflow: hidden;word-break:normal;font-size: 10.5pt;">
        	                        ${question.QuestionStem}
        	                       </div>`;
          }
          ///3.1, 最后一个Table补全.
          htmlDocument += "</td></tr></table></body></html>";
          //3.1 ,添加完题目后直接打印.
          let newWin = window.open("", "print");
          newWin.document.write(htmlDocument);
          newWin.document.close();
          setTimeout(function() {
            newWin.alert("请选择" + sizeType + "纸张，并选择无边距打印");
            newWin.print();
            setTimeout(function() {
              newWin.close();
            }, 100);
          }, 500);
        });
      } else if (this.task.Online == 4) {
        let htmlDocument = `<!DOCTYPE html><html lang="en"><head>
			    <meta charset="UTF-8">
			    <title>作业-${this.task.TaskName}</title>
			    <link rel="stylesheet" href="/static/css/iye-root-3.0.css?v=1.5"></link>
          <link rel="stylesheet" href="/static/css/paper-print.css?v=1.5"></link>
          <link rel="stylesheet" href="/static/css/questionStyle.css?v=1.5"></link>
			    <script src="/static/js/library.js"><\/script>
          <script src="/static/js/wangEditor.min.js"><\/script>
			</head>
			<body>`;
        let questionDiv = this.$refs.printContainer.innerHTML;
        htmlDocument = htmlDocument + questionDiv;
        htmlDocument += "</body></html>";
        //3.1 ,添加完题目后直接打印.
        let newWin = window.open("", "print");
        newWin.document.write(htmlDocument);
        newWin.document.close();
        setTimeout(function() {
          newWin.alert("请选择" + sizeType + "纸张，并选择无边距打印");
          newWin.print();
          setTimeout(function() {
            newWin.close();
          }, 100);
        }, 500);
      } else {
        let htmlStr = `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>${this.chapter}-${
          this.task.TaskName
        }</title><style>@page{  margin:0; } @page print{  margin:0; }html, body {padding:0; margin:0; color: #000;-webkit-font-smoothing: antialiased;font-family: 'Avenir', Helvetica, Arial, sans-serif;}</style></head><body>`;
        //2 生成中间html
        for (let i = 0; i < this.task.pages.length; i++) {
          htmlStr += `<table border="0" cellpadding="0" cellspacing="0"  style="page-break-after:always;width:${
            this.task.TrueWidth > 0 ? this.task.TrueWidth : this.task.pages[i].PageWidth
          }mm;height:${
            this.task.TrueHeight > 0 ? this.task.TrueHeight - 1 : this.task.pages[i].PageHeight - 1
          }mm;text-align: left" ><tr><td style="vertical-align: top">`;
          htmlStr += `<img src="${this.task.pages[i].PageImg}" style="max-width: ${
            this.task.TrueWidth > 0 ? this.task.TrueWidth : this.task.pages[i].PageWidth
          }mm;max-height: ${
            this.task.TrueHeight > 0 ? this.task.TrueHeight - 1 : this.task.pages[i].PageHeight - 1
          }mm;">`;
          htmlStr += `</td></tr></table>`;
        }
        //3 生成结束组成完成html
        htmlStr += `</body></html>`;
        let newWin = window.open("", "print");
        newWin.document.write(htmlStr);
        newWin.document.close();
        setTimeout(function() {
          newWin.alert("请选择" + sizeType + "纸张，并选择无边距打印");
          newWin.print();
          setTimeout(function() {
            newWin.close();
          }, 100);
        }, 500);
      }
    },
    /**
     * 导出PDF
     */
    async handleTaskExport() {
      let doc = new jsPDF("p", "mm", this.task.TrueWidth == 176 ? "b5" : "a4");
      const options = {
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        scale: 1,
        dpi: window.devicePixelRatio * 4,
      };
      const loading = this.$loading({
        lock: true,
        text: "导出中……",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let questionsPages;
      let imagePages;
      //生成图片添加到imgs中
      questionsPages = document.getElementById("questionsContainer").querySelectorAll(".task_page");
      if (this.task.Online == 1 || this.task.Online == 4) {
        questionsPages = document.getElementById("questionsContainer").querySelectorAll(".task_page");
      } else {
        let question2ImgForPrint = document.getElementById("question2ImgForPrint");
        question2ImgForPrint.innerHTML = "";
        for (let i = 0; i < this.task.pages.length; i++) {
          let pageHtml = `<table border="0" cellpadding="0" cellspacing="0"  style="page-break-after:always;width:${
            this.task.TrueWidth > 0 ? this.task.TrueWidth : this.task.pages[i].PageWidth
          }mm;height:${
            this.task.TrueHeight > 0 ? this.task.TrueHeight : this.task.pages[i].PageHeight
          }mm;text-align: left" ><tr><td style="vertical-align: middle">`;
          pageHtml += `<img src="${this.task.pages[i].PageImg}" style="max-width: ${
            this.task.TrueWidth > 0 ? this.task.TrueWidth : this.task.pages[i].PageWidth
          }mm;max-height: ${
            this.task.TrueHeight > 0 ? this.task.TrueHeight : this.task.pages[i].PageHeight
          }mm;display: block;" />`;
          pageHtml += `</td></tr></table>`;
          question2ImgForPrint.innerHTML += pageHtml;
        }
        questionsPages = question2ImgForPrint.querySelectorAll("table");
      }

      for (let i = 0; i < questionsPages.length; i++) {
        let quetoImg = questionsPages[i];
        let w = this.task.TrueWidth > 0 ? this.task.TrueWidth : this.task.pages[i].PageWidth;
        let h = this.task.TrueHeight > 0 ? this.task.TrueHeight : this.task.pages[i].PageHeight;
        await new html2canvas(quetoImg, options).then((canvas) => {
          let dataBase64 = canvas.toDataURL("image/jpeg", 1.0);
          if (i === questionsPages.length - 1) {
            doc.addImage(dataBase64, "jpeg", 0, 0, w, h);
            doc.save(this.task.TaskName + ".pdf");
            loading.close();
          }
          doc.addImage(dataBase64, "jpeg", 0, 0, w, h);
          doc.addPage();
        });
      }
    },
    reviewQuestionScroll(e) {
      this.newTop = parseFloat(e.target.scrollTop);
    },
    /*在线出题部分*/
    //在线出题  , 计算当前题目的分页
    questionPageCount(i, event) {
      // 如果加上该题刚好超过page页的倍数. 则当前页要分页.
      // 已经超过的, 则需要归0 , page页且加1,
      // let page = 1, pageHeight = 1122.52, nowheight = 0;
      let page = 1,
        pageHeight = Math.floor(((this.task.TrueHeight - this.task.PaddingWidth * 2) / 297) * 1122.52 * 100) / 100,
        nowheight = 0;
      for (let j = 0; j <= i; j++) {
        nowheight += this.questions[j].RegionH;
        //最后一个,且刚好大于 pageHeight,的倍数.
        if (i === j) {
          let isBig = nowheight > page * pageHeight;
          return isBig;
        }
        //不最最后一个, 则页数加1.
        if (nowheight > pageHeight * page) {
          nowheight = pageHeight * page + this.questions[j].RegionH;
          page++;
        }
      }
    },
    /**
     * 判断是否显示题型
     * @param pageIndex
     * @param questionIndex
     * @returns {boolean}
     */
    countShowType(pageIndex, questionIndex) {
      if (pageIndex >= 0 && questionIndex >= 0) {
        if (pageIndex == 0) {
          if (questionIndex == 0) {
            return true;
          } else {
            return (
              this.task.pages[pageIndex].questions[questionIndex - 1].QuestionType !=
              this.task.pages[pageIndex].questions[questionIndex].QuestionType
            );
          }
        } else {
          if (questionIndex == 0) {
            return (
              this.task.pages[pageIndex - 1].questions[this.task.pages[pageIndex - 1].questions.length - 1]
                .QuestionType != this.task.pages[pageIndex].questions[questionIndex].QuestionType
            );
          } else {
            return (
              this.task.pages[pageIndex].questions[questionIndex - 1].QuestionType !=
              this.task.pages[pageIndex].questions[questionIndex].QuestionType
            );
          }
        }
      } else {
        return false;
      }
    },
    /**
     * 计算题型总分
     */
    countTypeTotalScore(questionType) {
      let totalScore = 0;
      for (let que of this.questions) {
        if (que.QuestionType == questionType) {
          totalScore += que.Score;
        }
      }
      return totalScore;
    },
    /**
     * 计算题号
     * @param pageIndex 页index
     * @param questionIndex 题的index
     * @returns {*|number}
     */
    countType(pageIndex, questionIndex) {
      let count = 0;
      if (pageIndex > 0) {
        for (let i = 0; i < pageIndex; i++) {
          count += this.task.pages[i].questions.length;
        }
      }
      count = count + questionIndex + 1;
      return count;
    },
    questionDetailStyle(pageIndex, index) {
      let question = this.task.pages[pageIndex].questions[index];
      let pageQuestionsLength = this.task.pages[pageIndex].questions.length;
      let top = this.task.Online == 4 ? question.RegionY - 25 : question.RegionY;
      let height = this.task.Online == 4 ? question.RegionH + 25 + question.AdditionalAnswerArea : question.RegionH;
      let heightPX = Math.floor(((this.task.TrueHeight > 0 ? this.task.TrueHeight : 297) / 297) * 1122.52 * 100) / 100;
      return {
        top: top + "px",
        height: index == pageQuestionsLength - 1 ? this.task.TrueHeight - top + "px" : height + "px",
      };
    },
    openAnswerExplainBox(question) {
      this.activeQuestion = question;
      this.answerExplainBoxShow = true;
    },
    hideAnswerExplain() {
      this.answerExplainBoxShow = false;
    },
    setQuestionsPageScale() {
      //任务单真正的宽高，单位毫米mm
      let pageW = 0,
        pageH = 0;
      if (this.task.SizeType == 1) {
        //作业纸张大小为原教辅大小，但因所选的教辅大小可能不一样，宽度取最宽的页的宽，高度取各页的高度的和
        for (let page of this.task.pages) {
          if (page.PageWidth > pageW) {
            pageW = page.PageWidth;
          }
          pageH += page.PageHeight;
        }
        pageW = pageW ? pageW : 210;
        pageH = pageH ? pageH : 297;
      } else {
        // 作业纸张大小为A4\B3\自定义，每一页的纸张大小都一样；宽取设置的纸张大小的宽，高度为页数*每页的高
        pageW = this.task.TrueWidth;
        pageH = this.task.TrueHeight * this.pageCount;
      }
      // 毫米mm换算成像素px
      let w = Math.round((pageW / 210) * 793.69 * 100) / 100;
      let h = Math.round((pageH / 210) * 793.69 * 100) / 100;
      let PageWidth = (this.deviceWidth - 80 - 20 * 2) * 0.6;
      //计算margin值时总实际高度还需要加上页间距margin的值：20*(this.pageCount-1)
      let MarginTop = ((h + 10 * (this.pageCount - 1)) * (PageWidth / w - 1)) / 2;
      let MarginLeft = (PageWidth - w) / 2;
      document.getElementById("questionsContainer").style.cssText =
        "margin: " + MarginTop + "px " + MarginLeft + "px !important; ";
      this.pageScale = PageWidth / w;
      let questionsDivHeight = this.deviceHeight - 222;

      /* document.getElementsByClassName('questionsAnalysis')[0].style.cssText = 'height: ' + (questionsDivHeight + 60) + 'px;';
      document.querySelectorAll('#taskContainer>.questions')[0].style.cssText = 'height: ' + questionsDivHeight + 'px;';*/
      document.getElementById("questionsContainer").style.cssText +=
        "transform:scale(" +
        this.pageScale +
        ");-webkit-transform:scale(" +
        this.pageScale +
        ");-moz-transform:scale(" +
        this.pageScale +
        ");";
    },
    /* 打开题目预设的推题列表 */
    openPushed(question, index) {
      this.pushedData = question.TaskPrePushQuestions;

      if (this.pushedData.length > 0) {
        for (let pushQue of this.pushedData) {
          pushQue.PushID = pushQue.Data.ID;
          pushQue.Data.DetailSaved = true;
        }
        this.pushedDialog = true;
        /* let that = this;
        setTimeout(function() {
          that.computeOptionCols(that.pushedData);
        }, 300); */
      } else {
        this.$message.warning("还未预加入任何推题！");
      }
    },
  },
  watch: {
    /*$route(to, from) {
      //监听路由是否变化
      if (to.params.id != from.params.id) {
        this.taskID = this.$route.query.TaskListID ? this.$route.query.TaskListID : 0;
        this.SharedWork = this.$route.query.SharedWork ? this.$route.query.SharedWork : 0;
        this.getTaskDetail()
      }
    }*/
  },
  mounted() {
    // this.init()
    // this.getTaskDetail()
    let that = this;
    window.onresize = function() {
      that.deviceWidth = document.documentElement.clientWidth;
      that.deviceHeight = document.documentElement.clientHeight;
      // that.setQuestionsPageScale()
    };
    this.activeIndex = 0;
    this.activeQuestion = this.questions[this.activeIndex];
  },
  /*created() {
    window.myData = this
    if (this.$route.query) {
      this.taskID = this.$route.query.TaskListID ? this.$route.query.TaskListID : 0;
      this.SharedWork = this.$route.query.SharedWork != null ? this.$route.query.SharedWork : 0;
    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'overflow:hidden')
  },
  beforeDestroy() {
    document.body.removeAttribute('style')
  },*/
};
</script>

<style lang="less" scoped>
.student_detail {
  height: 100%;
  margin-top: 40px;

  .header {
    background-color: #fff;
    height: 40px;
    line-height: 40px;
    position: fixed;
    top: 50px;
    left: 20px;
    right: 20px;
    text-align: center;
    border-bottom: 1px solid #e5e5e5;
    padding: 0 40px 0 20px;
    z-index: 1000;

    .el-button--text {
      color: #333333;
      font-size: 16px;
    }

    .el-button--text.back {
      margin-right: 40px;
      position: relative;
      font-size: 14px;

      :after {
        content: "";
        position: absolute;
        width: 1px;
        height: 16px;
        right: -20px;
        top: 50%;
        transform: translateY(-50%);
        background-color: #dcdfe6;
      }

      i {
        margin-right: 6px;
      }
    }

    .name {
      text-align: center;
      font-size: 16px;
    }
  }

  .task_questions {
    .task_header {
      text-align: center;

      h2 {
        font-size: 18pt;
      }

      p {
        font-size: 12pt;
      }

      label {
        margin-right: 20px;
      }
    }
  }

  .questionsAnalysis {
    display: flex;
    position: relative;
    justify-content: center;
    margin: 10px auto;
  }

  #taskContainer {
    /*position: absolute;
    !*right: 40%;*!
    left: 0;
    top: 0;
    text-align: left;*/

    .question_page {
      display: flex;
      justify-content: center;
      padding: 5px;

      button {
        margin: 5px 5px;
        padding: 0 5px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 3px;
        color: #1e87f0;
        font-size: 18px;
        background: transparent;
        border: 1px solid #9e9e9e;

        &.active {
          background-color: #1e9fff;
          color: #fff;
          border: none;
        }
      }
    }

    .questions {
      height: 93%;
      /* background: #cecece;
      -moz-box-shadow: 0 6px 10px 0 #c2c2c2, 0 6px 20px 0 #666;
      -webkit-box-shadow: 0 6px 10px 0 #c2c2c2, 0 6px 20px 0 #666;
      box-shadow: 0 6px 10px 0 #c2c2c2, 0 6px 20px 0 #666; */
      /* transform:scale(1.2); */
      /* -webkit-transform:scale(1.2); */
      /*兼容-webkit-引擎浏览器*/
      /* -moz-transform:scale(1.2); */
      /*兼容-moz-引擎浏览器*/

      .task_page {
        position: relative;
        font-size: 10.5pt !important;
        color: #000000;
        font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB";
        word-break: normal;
        width: 210mm;
        height: 297mm;
        padding: 10mm;
        margin: 0 auto 1px;
        background: #fff;
        box-sizing: border-box;
        border-bottom: 1px solid #efefef;
        text-align: left;

        .push-count {
          position: absolute;
          right: -15px;
          top: -15px;
          background: #fd694c;
          color: #fff;
          width: 30px;
          height: 30px;
          border: 0;
          border-radius: 15px;
          line-height: 30px;
          text-align: center;
          font-size: 14px;
          cursor: pointer;
        }

        #taskPageOnline {
          .w-e-text.page-question-item {
            // border: 1px solid transparent;
            color: #000000;
            padding: 0;
            overflow: hidden;
          }

          .page-question-item.active {
            border: 1px solid #ff4e00;
          }
        }

        .w-e-text-container {
          font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif;
          overflow: visible;
					word-break: normal;
          //padding: 10mm;

          /deep/ a {
            color: rgb(0, 0, 238);
          }

          /deep/ p {
            font-size: 10.5pt !important;
						word-break: normal;
            strong {
              font-weight: 600;
            }
          }

          /deep/ .w-e-text img {
            vertical-align: top;
          }
        }

        #taskPageBook {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          display: flex;

          img {
            position: absolute;
            max-width: 210mm;
            max-height: 297mm;
          }

          .pageQuestion.active {
            border-color: #ff4e00;
          }

          .pageQuestion {
            box-sizing: border-box;
            position: absolute;
            z-index: 3;
            border: 1px solid #e4e4e4;
          }
        }

        #jiaofu {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;

          img {
            position: absolute;
            max-width: 210mm;
            max-height: 297mm;
          }

          .pageQuestion.active {
            border-color: #ff4e00;
          }

          .pageQuestion {
            box-sizing: border-box;
            position: absolute;
            z-index: 3;
            border: 1px solid #e4e4e4;
          }
        }

        .question-page {
          background: white;

          p {
            text-align: center;
            height: 30px;
            line-height: 30px;
            font-size: 11px;
            margin: 0;

            &.title-container {
              font-size: 20px;
            }

            .task-date {
            }
          }

          .question-item {
            width: 190mm;

            p.question-type {
              height: 30px;
              line-height: 30px;
              font-size: 18px;
              text-align: left;
              color: #333;
            }

            p.question-no {
              height: 25px;
              line-height: 25px;
              text-align: left;
              font-size: 15px;
              display: flex;
            }

            /* &:hover {
              div.question-content {
                border: 1px solid #409eff;

                p.buttons {
                  display: block;
                }
              }
            } */

            div.question-content {
              position: relative;
              border: none;
							word-break: normal;

              &.active {
                border: 1px solid #ff4e00;
                overflow: hidden;
              }

              p.buttons {
                display: none;
                position: absolute;
                top: -25px;
                height: 25px;
                right: 0;
                background: #409eff;
                color: white;

                button {
                  border: none;
                  background: transparent;
                  color: white;
                  margin: 5px 10px 0;
                  height: 20px;
                  font-size: 11px;
                  font-weight: bold;
                }
              }

              div.answer,
              div.explain {
                display: flex;

                span {
                  color: #409eff;
                  font-size: 15px;
                  margin-right: 10px;
                  width: 70px;
                }
              }
            }
          }
        }

        #studentAnswers {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;

          img {
            position: absolute;
            width: 210mm;
            height: 297mm;
          }
        }

        .questionAnswer {
          position: absolute;
          z-index: 4;
          text-align: center;

          img.piyue {
            position: absolute;
            top: 0;
            left: 0;
          }

          img.result {
            width: 60px;
            height: 60px;
            position: absolute;
            right: 10mm;

            &.right {
              width: 75px;
            }
          }

          div.score {
            color: #e50012;
            font-size: 28pt;
            font-weight: bold;
            font-style: italic;
            width: 100px;
            height: 35px;
            line-height: 35px;
            padding-right: 20px;
            position: absolute;
            right: 30px;
            bottom: 10px;
            text-align: right;

            img {
              position: absolute;
              bottom: 0;
              right: 25px;
              height: 60px;
              width: 75px;
            }
          }
        }

        .sign-canvas {
          position: absolute;
          z-index: 5;
        }
      }

      .TotalScore {
        position: absolute;
        color: #e50012;
        font-size: 55px;
        font-style: italic;
        width: 100px;
        height: 100px;
        line-height: 60px;
        right: 0;
        top: 0;
        text-align: center;
      }

      .TotalScore img {
        position: absolute;
        bottom: 0;
        right: 1mm;
        height: 90px;
        width: 90px;
      }
    }

    /* .questions::-webkit-scrollbar {
      width: 0;
    } */
  }

  .questionRight {
    flex: 1 1 auto;
    min-width: 80mm;
    max-width: 150mm;
    background: #fff;
    text-align: left;
    border-left: 1px dashed #e0e0e0;

    .questionInfo {
      position: sticky;
      padding: 10px;
      top: 60px;
      font-size: 15px;

      p,
      div {
        margin: 8px 0;
        /deep/ img {
          max-width: 100%;
        }
      }

      label {
        color: #409eff;
      }
    }
  }

  .question2ImgForPrint {
    position: absolute;
    z-index: -9999;
    left: -99999px;
    width: 210mm;
    height: 297mm;
    /*padding:10mm;*/
    font-weight: normal;
    font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased;
  }

  #answerExplainBox {
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    /* background-color: #717789;
    filter: alpha(opacity=60);
    background-color: rgba(113, 119, 137, .6);
    display: flex; */
  }

  #answerExplainBox .dialogbg {
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    background-color: #717789;
    filter: alpha(opacity=60);
    background-color: rgba(113, 119, 137, 0.6);
  }

  #answerExplainBox .contentDiv {
    background: #fff;
    width: 70%;
    height: 60%;
    margin: auto;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 5% 5%;
    color: #000;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }

  #answerExplainBox .contentDiv h2 {
    font-size: 18pt;
    text-align: center;
    margin-bottom: 35px;
    font-family: "微软雅黑", serif;
  }

  #answerExplainBox .contentDiv div.content {
    height: 100%;
    overflow: auto;
    font-size: 15pt;
    font-family: "宋体", serif;
  }

  .el-dialog__body {
    .contentDiv {
      h2 {
        font-size: 18pt;
        text-align: center;
        margin-bottom: 35px;
        font-family: "微软雅黑", serif;
      }

      div.content {
        max-height: 600px;
        overflow: auto;
        font-size: 14pt;
        font-family: "微软雅黑", serif;
      }
    }
  }

  #answerExplainBox .contentDiv div.content div {
    word-break: break-word;
  }

  #answerExplainBox .contentDiv div.content div::-webkit-scrollbar {
    width: 0;
  }

  #answerExplainBox .closeBox {
    position: absolute;
    left: unset;
    right: 10px;
    top: 10px;
    font-size: 18pt;
    height: auto;
  }

  .Questions {
    //共有的questions
    background: #f9f9f9;
    height: auto;
    position: relative;

    &.reviewQuestion {
      position: fixed;
      z-index: 99999;
      left: 50%;
      transform: translateX(-50%);
      background: #fff;
      width: 210mm;
      top: 20px;
      bottom: 20px;
      height: auto;
      overflow-y: auto;
      font-weight: normal;
      font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
      border: 5px solid #000;

      .printAndExport {
        position: fixed;
        transform: translateY(-50%);
        right: 20px;

        .el-button {
          padding: 5px 20px;
          width: 80px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail/TaskDetail.vue